import React from "react";
import { DocumentTextIcon, LinkIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";

export default function LegalSection({ appVersion, buildHash }) {
  const legalLinks = [
    {
      title: "Terms of Service",
      description: "Read how we run Traces and your rights.",
      href: "/terms",
    },
    {
      title: "Privacy Policy",
      description: "Learn what data we collect and why.",
      href: "/privacy",
    },
    {
      title: "Community Guidelines",
      description: "See what keeps our community safe.",
      href: "/community-guidelines",
    },
  ];

  return (
    <SettingsSection
      id="legal"
      title="Legal"
      icon={<DocumentTextIcon className="h-5 w-5 text-primary" />}
    >
      <div className="grid grid-cols-1 gap-4">
        {legalLinks.map((link) => (
          <a
            key={link.title}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group rounded-xl border border-border-light p-4 hover:bg-surface transition"
          >
            <div className="flex items-center gap-2 text-sm font-medium text-text-primary">
              {link.title}{" "}
              <LinkIcon className="h-4 w-4 text-text-muted group-hover:text-text-secondary" />
            </div>
            <p className="text-xs text-text-muted mt-1">{link.description}</p>
          </a>
        ))}
      </div>
      <div className="pt-2 text-xs text-text-muted">
        App version:{" "}
        <span className="font-mono text-text-secondary">{appVersion}</span> •
        Build:{" "}
        <span className="font-mono text-text-secondary">{buildHash}</span>
      </div>
    </SettingsSection>
  );
}
